
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum SiteType {
	WordPressProvisioningApi = 0,
	Dsa = 1,
	AspClassic = 2,
	DwsShop = 3,
	PrestaShop = 4,
	Unknown = 5,
	WebserverApi = 6,
	AiBuilder = 7
}
export namespace SiteType {
	export function getKeys(): Map<SiteType, string> {
		return new Map([[0, 'WordPressProvisioningApi'], [1, 'Dsa'], [2, 'AspClassic'], [3, 'DwsShop'], [4, 'PrestaShop'], [5, 'Unknown'], [6, 'WebserverApi'], [7, 'AiBuilder']]);
	}
}
